import members from './members'
import services from './_services'
import axios from 'axios'

export default {
  members,
  clearCache () {
    return new Promise((resolve, reject) => {
      services.post(process.env.ROOT_API + '/admin/clear_cache')
        .then(response => { resolve(response) })
        .catch(error => { reject(error) })
    })
  },
  getDashboard () {
    return services.get(process.env.ROOT_API + '/dashboard')
  },
  getAutocompleteAccountV2 (name) {
    return services.getWithParams(process.env.ROOT_API + '/accounts/autocomplete/v2', name)
  },
  getBoardOfDirectors (year = 2019) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.ROOT_API + '/board_of_directors/eligibility/' + year)
        .then(response => { resolve(response) })
        .catch(error => {
          reject(error)
        })
    })
  },
  getS3FileURL (filename) {
    return services.post(process.env.ROOT_API + '/s3', {'filename': filename})
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js